"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseLogger_1 = require("./BaseLogger");
var LSLogger = (function (_super) {
    __extends(LSLogger, _super);
    function LSLogger(name, url, interval, onLogs, perLength) {
        return _super.call(this, name, url, interval, onLogs, perLength) || this;
    }
    Object.defineProperty(LSLogger, "isSupport", {
        get: function () {
            return 'localStorage' in window;
        },
        enumerable: true,
        configurable: true
    });
    LSLogger.prototype.add = function (level, data, comment) {
        try {
            var logStr = window.localStorage.getItem(this.logName);
            var logs = logStr ? JSON.parse(logStr) : [];
            logs.push([Date.now(), level, data, comment]);
            window.localStorage.setItem(this.logName, JSON.stringify(logs));
        }
        catch (e) {
            this.clean();
            window.localStorage.setItem(this.logName, JSON.stringify([]));
        }
    };
    LSLogger.prototype.getLogByTime = function (from, to, callbackFn) {
        var result = [];
        try {
            var logs = JSON.parse(window.localStorage.getItem(this.logName));
            for (var i = 0; i < logs.length; i++) {
                if ((from && logs[i][0] < from) || (to && logs[i][0] > to)) {
                    continue;
                }
                result.push(logs[i]);
                logs.splice(i, 1);
                i--;
            }
            callbackFn(result);
            window.localStorage.setItem(this.logName, JSON.stringify(logs));
        }
        catch (e) {
            callbackFn([]);
        }
    };
    LSLogger.prototype.getLogByLen = function (len, callbackFn) {
        var result = [];
        try {
            var logs = JSON.parse(window.localStorage.getItem(this.logName));
            result = logs.splice(0, len);
            callbackFn(result);
        }
        catch (e) {
            callbackFn([]);
        }
    };
    LSLogger.prototype.keep = function (daysToMaintain) { };
    LSLogger.prototype.clean = function () {
        window.localStorage.removeItem(this.logName);
    };
    LSLogger.prototype.cleanByLen = function (len) {
        try {
            var logs = JSON.parse(window.localStorage.getItem(this.logName));
            logs.splice(0, len);
            window.localStorage.setItem(this.logName, JSON.stringify(logs));
        }
        catch (e) {
        }
    };
    LSLogger.prototype.initDB = function () {
        _super.prototype.initDB.call(this);
        try {
            if (!LSLogger.isSupport) {
                return;
            }
            if (!window.localStorage.getItem(this.logName)) {
                window.localStorage.setItem(this.logName, JSON.stringify([]));
            }
        }
        catch (e) {
        }
    };
    return LSLogger;
}(BaseLogger_1.BaseLogger));
exports.LSLogger = LSLogger;
//# sourceMappingURL=LSLogger.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/limi-lib/dist/lib/limi/log/LSLogger.js
// module id = riO/
// module chunks = 0